import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider as MuiDivider,
} from "@mui/material";
import {
  AddBoxOutlined as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { toast } from "react-toastify";

import {
  renderColumn,
  getSubFormContrlsObj,
  getNextSerial,
  saveSubFormRow,
  deleteSubFormRow,
} from "src/utils/amUtils";
//import AMMaterialTable from "src/pages/components/AMMatrialTable";
import AMFooterTable from "src/pages/components/AMFooterTable";
import FormInput from "src/pages/components/AMFormInput";
import * as Enums from "src/utils/enums";
import AMAutoComplete from "src/pages/components/AMAutoComplete";

import {
  getSubLedgersA,
  getSubLedgersB,
  getSubLedgersC,
  getSubLedgersD,
} from "src/services/GA/gaService";
import {
  getSelectedCompany,
  getSelectedBranch,
} from "src/services/httpService";

export default function LegerWithSubLedgers({
  ledgers,
  menuItemCode,
  formControls,
  errors,
  onChange,
  ledgerId,
  subLedgerAId,
  subLedgerBId,
  subLedgerCId,
  subLedgerDId,
  gridItemProps,
  ledgerIdFieldName,
  subLedgerAIdFieldName,
  subLedgerBIdFieldName,
  subLedgerCIdFieldName,
  subLedgerDIdFieldName,
}) {
  const [subLedgersA, setSubLedgersA] = useState([
    { valueField: 1, textField: "10- sgl 1", searchField: "1" },
    { valueField: 2, textField: "20- sgl 2", searchField: "2" },
    { valueField: 3, textField: "30- sgl 3", searchField: "3" },
    { valueField: 4, textField: "49- sgl 4", searchField: "4" },
  ]);
  const [subLedgersB, setSubLedgersB] = useState([]);
  const [subLedgersC, setSubLedgersC] = useState([]);
  const [subLedgersD, setSubLedgersD] = useState([]);

  const [loadingSubLedgersA, setLoadingSubLedgersA] = useState(false);
  const [loadingSubLedgersB, setLoadingSubLedgersB] = useState(false);
  const [loadingSubLedgersC, setLoadingSubLedgersC] = useState(false);
  const [loadingSubLedgersD, setLoadingSubLedgersD] = useState(false);

  const handleLedgerSelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    onChange(event, "", reason, subLedgerAIdFieldName);
    onChange(event, "", reason, subLedgerBIdFieldName);
    onChange(event, "", reason, subLedgerCIdFieldName);
    onChange(event, "", reason, subLedgerDIdFieldName);
    onChange(event, value, reason, fieldName); //Should be at the last because if Errors
  };

  const handleSubLedgerASelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    // setSubLedgersB([]);
    // setSubLedgersC([]);
    // setSubLedgersD([]);
    onChange(event, "", reason, subLedgerBIdFieldName);
    onChange(event, "", reason, subLedgerCIdFieldName);
    onChange(event, "", reason, subLedgerDIdFieldName);
    onChange(event, value, reason, fieldName);
  };

  const handleSubLedgerBSelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    // setSubLedgersC([]);
    // setSubLedgersD([]);
    onChange(event, "", reason, subLedgerCIdFieldName);
    onChange(event, "", reason, subLedgerDIdFieldName);
    onChange(event, value, reason, fieldName);
  };

  const handleSubLedgerCSelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    // setSubLedgersD([]);
    onChange(event, "", reason, subLedgerDIdFieldName);
    onChange(event, value, reason, fieldName);
  };

  const handleSubLedgerDSelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    onChange(event, value, reason, fieldName);
  };

  const selectedBranch = getSelectedBranch();

  const LoadSubLedgersA = async (active) => {
    if (loadingSubLedgersA) return;

    setLoadingSubLedgersA(true);
    if (active) {
      try {
        const { data } = await getSubLedgersA(menuItemCode, ledgerId);
        let d = [];
        try {
          d = JSON.parse(data);
        } catch (error) {}

        setSubLedgersA(d);
        if (
          selectedBranch &&
          selectedBranch.defaultSubLedgerA &&
          d &&
          d.length
        ) {
          const z = d.find(
            (x) => x.valueField == selectedBranch.defaultSubLedgerA
          );

          onChange(null, z, null, subLedgerAIdFieldName);
        } else if (d && d.length == 1) {
          onChange(null, d[0], null, subLedgerAIdFieldName);
        }
      } catch (error) {}

      setLoadingSubLedgersA(false);
    }
  };

  const LoadSubLedgersB = async (active) => {
    if (loadingSubLedgersB) return;

    setLoadingSubLedgersB(true);
    if (active) {
      try {
        const { data } = await getSubLedgersB(
          menuItemCode,
          ledgerId,
          subLedgerAId
        );
        let d = [];
        try {
          d = JSON.parse(data);
        } catch (error) {}

        setSubLedgersB(d);

        if (
          selectedBranch &&
          selectedBranch.defaultSubLedgerB &&
          d &&
          d.length
        ) {
          const z = d.find(
            (x) => x.valueField == selectedBranch.defaultSubLedgerB
          );

          onChange(null, z, null, subLedgerBIdFieldName);
        } else if (d && d.length == 1) {
          onChange(null, d[0], null, subLedgerBIdFieldName);
        }
      } catch (error) {}

      setLoadingSubLedgersB(false);
    }
  };

  const LoadSubLedgersC = async (active) => {
    if (loadingSubLedgersC) return;

    setLoadingSubLedgersC(true);
    if (active) {
      try {
        const { data } = await getSubLedgersC(
          menuItemCode,
          ledgerId,
          subLedgerAId,
          subLedgerBId
        );
        let d = [];
        try {
          d = JSON.parse(data);
        } catch (error) {}

        setSubLedgersC(d);
      } catch (error) {}

      setLoadingSubLedgersC(false);
    }
  };

  const LoadSubLedgersD = async (active) => {
    if (loadingSubLedgersD) return;

    setLoadingSubLedgersD(true);
    if (active) {
      try {
        const { data } = await getSubLedgersD(
          menuItemCode,
          ledgerId,
          subLedgerAId,
          subLedgerBId,
          subLedgerCId
        );
        let d = [];
        try {
          d = JSON.parse(data);
        } catch (error) {}

        setSubLedgersD(d);
      } catch (error) {}

      setLoadingSubLedgersD(false);
    }
  };

  useEffect(() => {
    if (ledgerId) {
      let active = true;
      LoadSubLedgersA(active);
      return () => {
        active = false;
      };
    } else {
      setSubLedgersA([]);
    }
  }, [ledgerId]);

  useEffect(() => {
    if (subLedgerAId) {
      let active = true;
      LoadSubLedgersB(active);
      return () => {
        active = false;
      };
    } else {
      setSubLedgersB([]);
    }
  }, [subLedgerAId]);

  useEffect(() => {
    if (subLedgerBId) {
      let active = true;
      LoadSubLedgersC(active);
      return () => {
        active = false;
      };
    } else {
      setSubLedgersC([]);
    }
  }, [subLedgerBId]);

  useEffect(() => {
    if (subLedgerCId) {
      let active = true;
      LoadSubLedgersD(active);
      return () => {
        active = false;
      };
    } else {
      setSubLedgersD([]);
    }
  }, [subLedgerCId]);

  let gridProps = {
    lg: 3,
    xl: 3,
    md: 6,
    sm: 6,
    xs: 12,
    style: { paddingBottom: 5, paddingTop: 5 },
  };
  if (gridItemProps && Object.keys(gridItemProps).length > 0) {
    gridProps = gridItemProps;
  }

  return (
    <>
      {!(
        formControls[ledgerIdFieldName] &&
        formControls[ledgerIdFieldName].isHidden
      ) && (
        <FormInput
          autoFocus={true}
          type={Enums.ControlType.AutoComplete}
          name={ledgerIdFieldName}
          control={formControls[ledgerIdFieldName]}
          onChange={handleLedgerSelectedIndexChanged}
          options={ledgers}
          value={ledgerId || ""}
          errorMsg={errors[ledgerIdFieldName]}
          gridItemProps={gridProps}
        />
      )}

      {!(
        formControls[subLedgerAIdFieldName] &&
        formControls[subLedgerAIdFieldName].isHidden
      ) && (
        <FormInput
          type={Enums.ControlType.AutoComplete}
          name={subLedgerAIdFieldName}
          control={formControls[subLedgerAIdFieldName]}
          onChange={handleSubLedgerASelectedIndexChanged}
          options={subLedgersA}
          value={subLedgerAId || ""}
          errorMsg={errors[subLedgerAIdFieldName]}
          gridItemProps={gridProps}
        />
      )}
      {!(
        formControls[subLedgerBIdFieldName] &&
        formControls[subLedgerBIdFieldName].isHidden
      ) && (
        <FormInput
          type={Enums.ControlType.AutoComplete}
          name={subLedgerBIdFieldName}
          control={formControls[subLedgerBIdFieldName]}
          onChange={handleSubLedgerBSelectedIndexChanged}
          options={subLedgersB}
          value={subLedgerBId || ""}
          errorMsg={errors[subLedgerBIdFieldName]}
          gridItemProps={gridProps}
        />
      )}
      {!(
        formControls[subLedgerCIdFieldName] &&
        formControls[subLedgerCIdFieldName].isHidden
      ) && (
        <FormInput
          type={Enums.ControlType.AutoComplete}
          name={subLedgerCIdFieldName}
          control={formControls[subLedgerCIdFieldName]}
          onChange={handleSubLedgerCSelectedIndexChanged}
          options={subLedgersC}
          value={subLedgerCId || ""}
          errorMsg={errors[subLedgerCIdFieldName]}
          gridItemProps={gridProps}
        />
      )}
      {!(
        formControls[subLedgerDIdFieldName] &&
        formControls[subLedgerDIdFieldName].isHidden
      ) && (
        <FormInput
          type={Enums.ControlType.AutoComplete}
          name={subLedgerDIdFieldName}
          control={formControls[subLedgerDIdFieldName]}
          onChange={handleSubLedgerDSelectedIndexChanged}
          options={subLedgersD}
          value={subLedgerDId || ""}
          errorMsg={errors[subLedgerDIdFieldName]}
          gridItemProps={gridProps}
        />
      )}
    </>
  );
}
